import "bootstrap/js/dist/alert"
import "bootstrap/js/dist/button"
import "bootstrap/js/dist/carousel"
import "bootstrap/js/dist/collapse"
import "bootstrap/js/dist/dropdown"
import "bootstrap/js/dist/modal"
import "bootstrap/js/dist/popover"
import "bootstrap/js/dist/scrollspy"
import "bootstrap/js/dist/tab"
import "bootstrap/js/dist/toast"
import "bootstrap/js/dist/tooltip"
import "bootstrap/js/dist/util"

import Rails from "@rails/ujs"
import axios from "axios"
import startApp from "./apps/App"
import "./passwordToggle"

Rails.start()

document.addEventListener("DOMContentLoaded", () => {
  const csrfMeta = document.querySelector('meta[name="csrf-token"]')
  if (csrfMeta) axios.defaults.headers.common["X-CSRF-Token"] = csrfMeta.content
  axios.defaults.headers.common.Accept = "application/json"
  axios.defaults.headers.common["Content-Type"] = "application/json"
  if (typeof gon !== "undefined" && gon.auth_token) {
    axios.defaults.headers.common["X-Auth-Token"] = gon.auth_token
  }

  const rootElem = document.getElementById("react-app")
  if (rootElem) startApp(rootElem)
})
